import React, { Fragment, useEffect } from 'react'
import { connect } from 'react-redux'
import Header4 from '../../../../../Header/Header4';
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'
import './style.css'
function ContactUs(props) {
    const { data } = props;
    useEffect(() => {
        console.log("ContactUs", window);
        // var map = window.BMapGL.Map('BMapGLMap_container'); // 创建Map实例
        // map.centerAndZoom(window.BMapGL.Point(116.404, 39.915), 12); // 初始化地图,设置中心点坐标和地图级别
        // map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放

        var map2 = new window.BMap.Map("BMapGLMap_container");            // 创建Map实例
        var point2 = new window.BMap.Point(116.28871, 40.078257);
        var marker = new window.BMap.Marker(new window.BMap.Point(116.28871, 40.078257));
        var top_left_navigation = new window.BMap.NavigationControl();
        map2.centerAndZoom(point2, 18);
        map2.enableScrollWheelZoom();                  //启用滚轮放大缩小
        map2.addOverlay(marker);
        map2.addControl(new window.BMap.NavigationControl());
    }, [])
    const infoList = [
        {
            img: 'images/ThreeUs/ContactUs/1.png',
            infoName: "电话",
            infoContent: "010-64839949",
        },
        {
            img: 'images/ThreeUs/ContactUs/2.png',
            infoName: "传真",
            infoContent: "010-64839949",
        },
        {
            img: 'images/ThreeUs/ContactUs/3.png',
            infoName: "邮箱",
            infoContent: "nsicat@126.com",
        },
        {
            img: 'images/ThreeUs/ContactUs/4.png',
            infoName: "地址",
            infoContent: "北京市海淀区邓庄南路9号（邮编：100094）",
        },
    ]
    return (
        <div className='Home_Introduce' >
            <div className='Home_IntroduceMain' id='Home_IntroduceMain'>
                <div className='Home_IntroduceTitle'>
                    {props.loginObj && props.loginObj.login && props.loginObj.token !== undefined
                        ?
                        <Header4 />
                        :
                        <HomeHearder />
                    }
                </div>
                <div className='Home_IntroduceMainScroll' >
                    <div className='Home_IntroduceContent'>
                        <div className='Home_ContactUs'>
                            <div className='Home_ContactUs_Title'>
                                <div className='Home_ContactUs_TitleCN'>联系我们</div>
                                <div className='Home_ContactUs_TitleEN'>Contact us</div>
                            </div>
                            <div className='Home_ContactUs_Content'>
                                <div className='Home_ContactUs_Info'>
                                    {infoList.map((info) => {
                                        return <ContactInfo data={info} />
                                    })}
                                </div>
                                <div className='Home_ContactUs_Map' id='BMapGLMap_container'>

                                </div>
                            </div>
                        </div>
                    </div>
                    <MainBottom data={unitsList} />
                </div>
            </div>
        </div>
    )
}

const ContactInfo = (props) => {
    const { data } = props;
    return (
        <div className='ContactInfo'>
            <img className='ContactInfoIcon' src={data.img} />
            <div className='ContactInfoContent'>{`${data.infoName}：${data.infoContent}`}</div>
        </div>
    )
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({
})
export default connect(mapState, mapDispatch)(ContactUs);